import { MoneyString } from 'model/Money'
import { useTranslation } from 'react-i18next'
import { MoneyDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ValueLabelConnected } from '../store/components/ValueLabelConnected'
import { bomItemFinancialSelector } from '../store/selectors/bomItemFinancialSelector'

export const BomItemTotalPrice = ({ bomItemId }: { bomItemId: string }) => {
  const { t } = useTranslation()
  return (
    <ValueLabelConnected
      propertySelector={(state) =>
        MoneyString(
          bomItemFinancialSelector(
            bomItemId,
            'salesPriceOfItems'
          )(state) as MoneyDto
        )
      }
      valueLabelProps={{
        label: t('project:total-price'),
      }}
    />
  )
}
